import m from "./../../../dist/es2015/locales/de_CH.js";
export const am5locales_de_CH = m;